import { getUserTimeZone } from "../utils/user-helpers";
import i18n from "../i18n";
import getErrorMessage from "../utils/getErrorMessage";

const Questionnaire = (app) => {
  app
    .post(
      "/questionnaire/save-athlete-changes",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        const { isDeleting } = body;

        if (!isDeleting) {
          assert(
            body.questions,
            400,
            i18n.t("coaching-portal:questionnaireActions.provideQuestionsList")
          );
        }

        try {
          await api("athlete-questionnaire", {
            method: "POST",
            body,
          });

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyUpdated"));
          res.refreshWith({}, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/add-template",
      async ({ api, assert, flash, req, res }) => {
        const { body, query } = req;
        const { templateId, fromEdit } = query;
        const method = templateId ? "PUT" : "POST";

        try {
          await api("questionnaire-template", {
            method: method,
            body: body,
          });

          flash(
            "success",
            method === "POST" ? i18n.t("coaching-portal:questionnaireActions.successfullyAddedTemplate") : i18n.t("coaching-portal:questionnaireActions.successfullyUpdatedTemplate")
          );
          if (fromEdit === "true" || fromEdit === true) {
            res.refreshWith(
              { modal: "", fromEdit: "" },
              { url: "back", hash: "#_" }
            );
          } else {
            res.refreshWith(
              { "modal[type]": "questionnaire-templates", templateId: "" },
              { url: "back", hash: "#_" }
            );
          }
        } catch (e) {
          flash("error", e.message);
          if (fromEdit === "true" || fromEdit === true) {
            res.refreshWith(
              { modal: "", fromEdit: "" },
              { url: "back", hash: "#_" }
            );
          } else {
            res.refreshWith(
              { "modal[type]": "questionnaire-templates", templateId: "" },
              { url: "back", hash: "#_" }
            );
          }
        }
      }
    )
    .post(
      "/questionnaire/assign-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        try {
          await api("questionnaire-template-assign", {
            method: "POST",
            body,
          });
          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyAssigned"));
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/remove-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        const {
          templateId,
          userToRequest = undefined,
          organizationOwner = undefined,
        } = body;

        try {
          await api(
            `questionnaire-template?templateId=${templateId}&userToRequest=${userToRequest}&organizationOwner=${organizationOwner}`,
            {
              method: "DELETE",
            }
          );

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyRemoved"));
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/duplicate-template",
      async ({ api, flash, req, res }) => {
        const { body } = req;

        try {
          await api("questionnaire-template/duplicate", {
            method: "POST",
            body,
          });

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyDuplicatedTemplate"));
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/add-default-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        try {
          await api("questionnaire-template/set-default", {
            method: "POST",
            body,
          });

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyAssignedDefaultTemplate"));
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/remove-default-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        const {
          templateId,
          userToRequest = undefined,
          organizationOwner = undefined,
        } = body;

        const organizationOwnerParam = organizationOwner
          ? `&organizationOwner=${organizationOwner}`
          : "";
        const urlToRequest = `questionnaire-template/set-default?templateId=${templateId}&userToRequest=${userToRequest}${organizationOwnerParam}`;

        try {
          await api(urlToRequest, {
            method: "DELETE",
          });

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyRemovedDefaultTemplate"));
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/add-schedule",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;

        try {
          const { startDay, frequency } = body.schedule;

          assert(frequency, 400, i18n.t("coaching-portal:questionnaireActions.selectFrequency"));
          assert(startDay, 400, i18n.t("coaching-portal:questionnaireActions.selectDay"));

          const userTimeZone = getUserTimeZone();
          body.userTimeZone = userTimeZone;

          await api("athlete-questionnaire-schedule", { method: "POST", body });

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyScheduled"));
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        } catch (error) {
          flash("error", getErrorMessage(error));
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    )
    .post(
      "/questionnaire/remove-schedule",
      async ({ api, flash, req, res }) => {
        const { body } = req;

        try {
          await api(
            `athlete-questionnaire-schedule?athleteId=${body.athleteId}&userToRequest=${body.userToRequest}`,
            {
              method: "DELETE",
            }
          );

          flash("success", i18n.t("coaching-portal:questionnaireActions.successfullyUnscheduled"));
          res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
        } catch (error) {
          flash("error", getErrorMessage(error));
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      }
    );
};

export default Questionnaire;
